import React, { useEffect, useState } from "react";
import {
    Routes as Switch,
    Route,
    useLocation,
    useNavigate,
} from "react-router-dom";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
    userInfo,
    userCredentials,
    services,
    snackbarData,
} from "./recoilState/GlobalState";
import { getUserCredentials } from "services/getUserCredentials";
import { checkAuth } from "services/checkAuth";
import { usuarioMinimosGet } from "services/services-mia";
import ProtectedRoute from "./components/route/ProtectedRoute";
import { CircularIndeterminate, Header } from "components";
import SnackBar from "components/utils/snackbars/Snackbar";
import { Dashboard, Usuarios, Login, UserDetailsDashboard } from "./pages";
import { Routes as ROUTES } from "./consts/Routes-App";
import ServiceRoute from "components/route/ServiceRoute";
import { merchantLogoGet } from "services/services-mia/merchant";
import { SFServicioGet } from "services/services-mia/SFServicioGet";
import s from "./App.module.scss";
import { subscribe, unsubscribe } from "./utils/eventManager.js";

import HabitacionesHotel from "pages/hoteles/habitaciones";
import OcupacionHotel from "pages/hoteles/ocupacion";
import HotelesList from "pages/hoteles/hoteles";
import UsuariosHotel from "pages/hoteles/usuarios/Usuarios";


export default function App() {
    const [loading, setLoading] = useState(true);
    const [isAuth, setIsAuth] = useState(false);
    const [credentials, setCredentials] = useRecoilState(userCredentials);
    const [info, setInfo] = useRecoilState(userInfo);
    const setServices = useSetRecoilState(services);
    const setSnackBarInfo = useSetRecoilState(snackbarData);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true);

        (async () => {
            const newCredentials = await getUserCredentials();

            if (newCredentials) {
                setCredentials(newCredentials);

                const userData = await usuarioMinimosGet(newCredentials);
                setInfo(userData);

                const { result: servicesData } = await SFServicioGet(
                    {},
                    newCredentials
                );

                setServices(servicesData);
            }

            setIsAuth(checkAuth());

            setLoading(false);
        })();
    }, [setCredentials, setInfo, setServices]);

    useEffect(() => {
        if (loading) return;

        setIsAuth(checkAuth());
    }, [credentials, loading]);

    useEffect(() => {
        const handleErrorServer = (data) => {
            setSnackBarInfo({
                message: data.message,
                severity: "warning",
                open: true,
            });
        };

        const handleSessionExpired = (data) => {
            setSnackBarInfo({
                message: data.message,
                severity: "warning",
                open: true,
            });

            navigate(ROUTES.login.route);
        };

        subscribe("serverError", handleErrorServer);
        subscribe("sessionExpired", handleSessionExpired);

        return () => {
            unsubscribe("serverError", handleErrorServer);
            unsubscribe("sessionExpired", handleSessionExpired);
        };
    }, [navigate, setSnackBarInfo]);

    if (loading) return <CircularIndeterminate />;

    return (
        <div className={s.container}>
            <div className={isAuth.header}>
                {location.pathname !== ROUTES.login.route && <Header />}
            </div>

            <div className={s.body}>
                <SnackBar />

                <Switch>
                    <Route
                        path={ROUTES.login.route}
                        exact
                        element={<Login />}
                    />

                    <Route
                        element={
                            <ProtectedRoute
                                redirectProtectedRoute={ROUTES.login.route}
                                isAuth={isAuth}
                            />
                        }
                    >
                        <Route
                            path={ROUTES.dashboard.route}
                            exact
                            element={<Dashboard route={ROUTES.dashboard} />}
                        />

                        <Route
                            path={ROUTES.usuarios.route}
                            exact
                            element={<Usuarios route={ROUTES.usuarios} />}
                        />

                        <Route
                            path={"usuarios/:usuarioId/details"}
                            element={<UserDetailsDashboard />}
                        />

                        <Route
                            path="servicio/SFHOTEL"
                            element={
                                <ServiceRoute
                                    servicioCod="SFHOTEL"
                                    redirectProtectedRoute={ROUTES.login.route}
                                />
                            }
                        >
                            <Route path="usuarios" element={<UsuariosHotel />} />

                            <Route path="hoteles" element={<HotelesList />} />

                            <Route
                                path="habitaciones"
                                element={<HabitacionesHotel />}
                            />

                            <Route
                                path="ocupacion"
                                element={<OcupacionHotel />}
                            />
                        </Route>

                        <Route path="/*" element={<Dashboard />} />
                    </Route>
                </Switch>
            </div>
        </div>
    );
}
